/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { ConfirmationPublicCreateMediaRequest } from '../model';
// @ts-ignore
import { ConfirmationPublicMediaRead } from '../model';
// @ts-ignore
import { ConfirmationPublicMediaSignatureRequest } from '../model';
// @ts-ignore
import { DataRequestRecipientDeclinePublicRequest } from '../model';
// @ts-ignore
import { DataRequestRecipientPublic } from '../model';
// @ts-ignore
import { DataRequestRecipientSubmitPublicRequest } from '../model';
// @ts-ignore
import { DataRequestSubmittedPublic } from '../model';
// @ts-ignore
import { MediaSignature } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * PublicBookingDataRequestApi - axios parameter creator
 * @export
 */
export const PublicBookingDataRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Declines a Booking Data Request.
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {DataRequestRecipientDeclinePublicRequest} [dataRequestRecipientDeclinePublicRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestDeclineCreate: async (recipientId: string, aaSource?: string, dataRequestRecipientDeclinePublicRequest?: DataRequestRecipientDeclinePublicRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingDataRequestDeclineCreate', 'recipientId', recipientId)
            const localVarPath = `/v2/public/booking/data-request/{recipient_id}/decline`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataRequestRecipientDeclinePublicRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads media against the Data Request
         * @param {string} recipientId 
         * @param {ConfirmationPublicCreateMediaRequest} confirmationPublicCreateMediaRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestMediaCreate: async (recipientId: string, confirmationPublicCreateMediaRequest: ConfirmationPublicCreateMediaRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingDataRequestMediaCreate', 'recipientId', recipientId)
            // verify required parameter 'confirmationPublicCreateMediaRequest' is not null or undefined
            assertParamExists('publicBookingDataRequestMediaCreate', 'confirmationPublicCreateMediaRequest', confirmationPublicCreateMediaRequest)
            const localVarPath = `/v2/public/booking/data-request/{recipient_id}/media`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmationPublicCreateMediaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates a signature to allow content to be uploaded to Cloudinary directly
         * @param {string} recipientId 
         * @param {ConfirmationPublicMediaSignatureRequest} confirmationPublicMediaSignatureRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestMediaSignatureCreate: async (recipientId: string, confirmationPublicMediaSignatureRequest: ConfirmationPublicMediaSignatureRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingDataRequestMediaSignatureCreate', 'recipientId', recipientId)
            // verify required parameter 'confirmationPublicMediaSignatureRequest' is not null or undefined
            assertParamExists('publicBookingDataRequestMediaSignatureCreate', 'confirmationPublicMediaSignatureRequest', confirmationPublicMediaSignatureRequest)
            const localVarPath = `/v2/public/booking/data-request/{recipient_id}/media/signature`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmationPublicMediaSignatureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the public information about the Booking Data Request
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestRetrieve: async (recipientId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingDataRequestRetrieve', 'recipientId', recipientId)
            const localVarPath = `/v2/public/booking/data-request/{recipient_id}`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A submission can only occur when the DataRequest is the latest for the Booking and the status of the DataRequest is OPEN. If theres any issue when submitting the DataRequest the message for why will be returned in the `detail` key in the body.  The returned content will be a link to open the users SMS app with the recipient being the Data Request owner and the content from the `booking_data_request_completed_sms` template. 
         * @summary Submits the Booking Data Request
         * @param {string} recipientId 
         * @param {DataRequestRecipientSubmitPublicRequest} dataRequestRecipientSubmitPublicRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestSubmitCreate: async (recipientId: string, dataRequestRecipientSubmitPublicRequest: DataRequestRecipientSubmitPublicRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingDataRequestSubmitCreate', 'recipientId', recipientId)
            // verify required parameter 'dataRequestRecipientSubmitPublicRequest' is not null or undefined
            assertParamExists('publicBookingDataRequestSubmitCreate', 'dataRequestRecipientSubmitPublicRequest', dataRequestRecipientSubmitPublicRequest)
            const localVarPath = `/v2/public/booking/data-request/{recipient_id}/submit`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataRequestRecipientSubmitPublicRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicBookingDataRequestApi - functional programming interface
 * @export
 */
export const PublicBookingDataRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicBookingDataRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Declines a Booking Data Request.
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {DataRequestRecipientDeclinePublicRequest} [dataRequestRecipientDeclinePublicRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingDataRequestDeclineCreate(recipientId: string, aaSource?: string, dataRequestRecipientDeclinePublicRequest?: DataRequestRecipientDeclinePublicRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataRequestRecipientPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingDataRequestDeclineCreate(recipientId, aaSource, dataRequestRecipientDeclinePublicRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Uploads media against the Data Request
         * @param {string} recipientId 
         * @param {ConfirmationPublicCreateMediaRequest} confirmationPublicCreateMediaRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingDataRequestMediaCreate(recipientId: string, confirmationPublicCreateMediaRequest: ConfirmationPublicCreateMediaRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationPublicMediaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingDataRequestMediaCreate(recipientId, confirmationPublicCreateMediaRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generates a signature to allow content to be uploaded to Cloudinary directly
         * @param {string} recipientId 
         * @param {ConfirmationPublicMediaSignatureRequest} confirmationPublicMediaSignatureRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingDataRequestMediaSignatureCreate(recipientId: string, confirmationPublicMediaSignatureRequest: ConfirmationPublicMediaSignatureRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaSignature>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingDataRequestMediaSignatureCreate(recipientId, confirmationPublicMediaSignatureRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch the public information about the Booking Data Request
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingDataRequestRetrieve(recipientId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataRequestRecipientPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingDataRequestRetrieve(recipientId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A submission can only occur when the DataRequest is the latest for the Booking and the status of the DataRequest is OPEN. If theres any issue when submitting the DataRequest the message for why will be returned in the `detail` key in the body.  The returned content will be a link to open the users SMS app with the recipient being the Data Request owner and the content from the `booking_data_request_completed_sms` template. 
         * @summary Submits the Booking Data Request
         * @param {string} recipientId 
         * @param {DataRequestRecipientSubmitPublicRequest} dataRequestRecipientSubmitPublicRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingDataRequestSubmitCreate(recipientId: string, dataRequestRecipientSubmitPublicRequest: DataRequestRecipientSubmitPublicRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataRequestSubmittedPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingDataRequestSubmitCreate(recipientId, dataRequestRecipientSubmitPublicRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicBookingDataRequestApi - factory interface
 * @export
 */
export const PublicBookingDataRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicBookingDataRequestApiFp(configuration)
    return {
        /**
         * 
         * @summary Declines a Booking Data Request.
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {DataRequestRecipientDeclinePublicRequest} [dataRequestRecipientDeclinePublicRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestDeclineCreate(recipientId: string, aaSource?: string, dataRequestRecipientDeclinePublicRequest?: DataRequestRecipientDeclinePublicRequest, options?: any): AxiosPromise<DataRequestRecipientPublic> {
            return localVarFp.publicBookingDataRequestDeclineCreate(recipientId, aaSource, dataRequestRecipientDeclinePublicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads media against the Data Request
         * @param {string} recipientId 
         * @param {ConfirmationPublicCreateMediaRequest} confirmationPublicCreateMediaRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestMediaCreate(recipientId: string, confirmationPublicCreateMediaRequest: ConfirmationPublicCreateMediaRequest, aaSource?: string, options?: any): AxiosPromise<ConfirmationPublicMediaRead> {
            return localVarFp.publicBookingDataRequestMediaCreate(recipientId, confirmationPublicCreateMediaRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates a signature to allow content to be uploaded to Cloudinary directly
         * @param {string} recipientId 
         * @param {ConfirmationPublicMediaSignatureRequest} confirmationPublicMediaSignatureRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestMediaSignatureCreate(recipientId: string, confirmationPublicMediaSignatureRequest: ConfirmationPublicMediaSignatureRequest, aaSource?: string, options?: any): AxiosPromise<MediaSignature> {
            return localVarFp.publicBookingDataRequestMediaSignatureCreate(recipientId, confirmationPublicMediaSignatureRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the public information about the Booking Data Request
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestRetrieve(recipientId: string, aaSource?: string, options?: any): AxiosPromise<DataRequestRecipientPublic> {
            return localVarFp.publicBookingDataRequestRetrieve(recipientId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * A submission can only occur when the DataRequest is the latest for the Booking and the status of the DataRequest is OPEN. If theres any issue when submitting the DataRequest the message for why will be returned in the `detail` key in the body.  The returned content will be a link to open the users SMS app with the recipient being the Data Request owner and the content from the `booking_data_request_completed_sms` template. 
         * @summary Submits the Booking Data Request
         * @param {string} recipientId 
         * @param {DataRequestRecipientSubmitPublicRequest} dataRequestRecipientSubmitPublicRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestSubmitCreate(recipientId: string, dataRequestRecipientSubmitPublicRequest: DataRequestRecipientSubmitPublicRequest, aaSource?: string, options?: any): AxiosPromise<DataRequestSubmittedPublic> {
            return localVarFp.publicBookingDataRequestSubmitCreate(recipientId, dataRequestRecipientSubmitPublicRequest, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for publicBookingDataRequestDeclineCreate operation in PublicBookingDataRequestApi.
 * @export
 * @interface PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreateRequest
 */
export interface PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreate
     */
    readonly recipientId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {DataRequestRecipientDeclinePublicRequest}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreate
     */
    readonly dataRequestRecipientDeclinePublicRequest?: DataRequestRecipientDeclinePublicRequest
}

/**
 * Request parameters for publicBookingDataRequestMediaCreate operation in PublicBookingDataRequestApi.
 * @export
 * @interface PublicBookingDataRequestApiPublicBookingDataRequestMediaCreateRequest
 */
export interface PublicBookingDataRequestApiPublicBookingDataRequestMediaCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestMediaCreate
     */
    readonly recipientId: string

    /**
     * 
     * @type {ConfirmationPublicCreateMediaRequest}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestMediaCreate
     */
    readonly confirmationPublicCreateMediaRequest: ConfirmationPublicCreateMediaRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestMediaCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for publicBookingDataRequestMediaSignatureCreate operation in PublicBookingDataRequestApi.
 * @export
 * @interface PublicBookingDataRequestApiPublicBookingDataRequestMediaSignatureCreateRequest
 */
export interface PublicBookingDataRequestApiPublicBookingDataRequestMediaSignatureCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestMediaSignatureCreate
     */
    readonly recipientId: string

    /**
     * 
     * @type {ConfirmationPublicMediaSignatureRequest}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestMediaSignatureCreate
     */
    readonly confirmationPublicMediaSignatureRequest: ConfirmationPublicMediaSignatureRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestMediaSignatureCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for publicBookingDataRequestRetrieve operation in PublicBookingDataRequestApi.
 * @export
 * @interface PublicBookingDataRequestApiPublicBookingDataRequestRetrieveRequest
 */
export interface PublicBookingDataRequestApiPublicBookingDataRequestRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestRetrieve
     */
    readonly recipientId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for publicBookingDataRequestSubmitCreate operation in PublicBookingDataRequestApi.
 * @export
 * @interface PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreateRequest
 */
export interface PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreate
     */
    readonly recipientId: string

    /**
     * 
     * @type {DataRequestRecipientSubmitPublicRequest}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreate
     */
    readonly dataRequestRecipientSubmitPublicRequest: DataRequestRecipientSubmitPublicRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreate
     */
    readonly aaSource?: string
}

/**
 * PublicBookingDataRequestApi - object-oriented interface
 * @export
 * @class PublicBookingDataRequestApi
 * @extends {BaseAPI}
 */
export class PublicBookingDataRequestApi extends BaseAPI {
    /**
     * 
     * @summary Declines a Booking Data Request.
     * @param {PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingDataRequestApi
     */
    public publicBookingDataRequestDeclineCreate(requestParameters: PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreateRequest, options?: any) {
        return PublicBookingDataRequestApiFp(this.configuration).publicBookingDataRequestDeclineCreate(requestParameters.recipientId, requestParameters.aaSource, requestParameters.dataRequestRecipientDeclinePublicRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads media against the Data Request
     * @param {PublicBookingDataRequestApiPublicBookingDataRequestMediaCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingDataRequestApi
     */
    public publicBookingDataRequestMediaCreate(requestParameters: PublicBookingDataRequestApiPublicBookingDataRequestMediaCreateRequest, options?: any) {
        return PublicBookingDataRequestApiFp(this.configuration).publicBookingDataRequestMediaCreate(requestParameters.recipientId, requestParameters.confirmationPublicCreateMediaRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates a signature to allow content to be uploaded to Cloudinary directly
     * @param {PublicBookingDataRequestApiPublicBookingDataRequestMediaSignatureCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingDataRequestApi
     */
    public publicBookingDataRequestMediaSignatureCreate(requestParameters: PublicBookingDataRequestApiPublicBookingDataRequestMediaSignatureCreateRequest, options?: any) {
        return PublicBookingDataRequestApiFp(this.configuration).publicBookingDataRequestMediaSignatureCreate(requestParameters.recipientId, requestParameters.confirmationPublicMediaSignatureRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the public information about the Booking Data Request
     * @param {PublicBookingDataRequestApiPublicBookingDataRequestRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingDataRequestApi
     */
    public publicBookingDataRequestRetrieve(requestParameters: PublicBookingDataRequestApiPublicBookingDataRequestRetrieveRequest, options?: any) {
        return PublicBookingDataRequestApiFp(this.configuration).publicBookingDataRequestRetrieve(requestParameters.recipientId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A submission can only occur when the DataRequest is the latest for the Booking and the status of the DataRequest is OPEN. If theres any issue when submitting the DataRequest the message for why will be returned in the `detail` key in the body.  The returned content will be a link to open the users SMS app with the recipient being the Data Request owner and the content from the `booking_data_request_completed_sms` template. 
     * @summary Submits the Booking Data Request
     * @param {PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingDataRequestApi
     */
    public publicBookingDataRequestSubmitCreate(requestParameters: PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreateRequest, options?: any) {
        return PublicBookingDataRequestApiFp(this.configuration).publicBookingDataRequestSubmitCreate(requestParameters.recipientId, requestParameters.dataRequestRecipientSubmitPublicRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
